import * as actionType from "./Action_Type";
import { CALL_API } from "../Middlewares/api";
import { sortList } from "../Utils/Sorting";
import * as SGUri from "../Utils/PagesSwitch.js";
import { PLANT_GET_LIST, PLANT_ADD_MODIFY, PLANT_GET_LIST_TUPLE } from "../Utils/Strings/Service_Endpoint";
import { refreshList, requestList } from "./Action_Utils.js";

export function getListaImpianti(filter) {
  var obj = {
    Nome       :filter.Nome,      
    Citta      :filter.Citta,     
    Provincia  :filter.Provincia, 
    Piva       :filter.Piva,      
    Indirizzo  :filter.Indirizzo, 
    Cap        :filter.Cap,       
    Cancellata :filter.Cancellata,
    Telefono   :filter.Telefono,  
    Email      :filter.Email,     
    IDHolding  :filter.IDHolding, 
    Cancellata :filter.Cancellata,
    IDAzienda  :filter.IDAzienda
  };

  return {
    [CALL_API]: {
      endpoint: PLANT_GET_LIST+SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_IMPIANTI_LIST_REQUEST,
        actionType.SERVICE_IMPIANTI_LIST_SUCCESS,
        actionType.SERVICE_IMPIANTI_LIST_ERROR
      ]
    }
  };
}

export const orderListaImpianti = (holdList, value) => {
  return dispatch => {
     dispatch(requestList(actionType.SERVICE_AZIENDE_LIST_REQUEST));
     dispatch(refreshList(sortList(holdList, value), actionType.SERVICE_AZIENDE_REFRESH_LIST));
   }
}

export function setImpianto(impianto) {
  var obj = {
    ID         : impianto.ID,
    Nome       : impianto.Nome,
    Indirizzo  : impianto.Indirizzo,
    Citta      : impianto.Citta,
    Provincia  : impianto.Provincia,
    Cap        : impianto.Cap,
    Telefono   : impianto.Telefono,
    Email      : impianto.Email,
    Holding    : impianto.Holding,
    Azienda    : impianto.Azienda,
    Cancellato : impianto.Cancellato,
    IDMaster   : impianto.IDMaster
  };
  return {
    [CALL_API]: {
      endpoint      : PLANT_ADD_MODIFY,
      authenticated : true,
      method        : "POST",
      types         : [
        actionType.SERVICE_IMPIANTI_SET_REQUEST,
        actionType.SERVICE_IMPIANTI_SET_SUCCESS,
        actionType.SERVICE_IMPIANTI_SET_ERROR
      ],
      data : SGUri.serializeParametersPOST(obj),
    }
  };
}

export function getListaImpiantiTupla(IDHolding, IDAzienda) {
  var obj = {
    IDHolding : IDHolding,
    IDAzienda : IDAzienda
  };
  return {
    [CALL_API]: {
      endpoint: PLANT_GET_LIST_TUPLE+SGUri.serializeParameters(obj),
      authenticated: true,
      types: [
        actionType.SERVICE_IMPIANTI_TUPLA_LIST_REQUEST,
        actionType.SERVICE_IMPIANTI_TUPLA_LIST_SUCCESS,
        actionType.SERVICE_IMPIANTI_TUPLA_LIST_ERROR
      ]
    }
  };
}


// WEBPACK FOOTER //
// ./src/Actions/Action_ServiceRequest_Impianti.js